import { AuthError } from './authError'

export const handleApiResponse = (response) => {
  const status = response.status

  switch (status) {
    case 401:
      return Promise.reject(new AuthError())
    case 403:
      return Promise.reject({
        response: {
          title: status,
          detail: response.statusText,
          violations: [],
        },
      })
    default:
      break
  }

  const contentType = response.headers.get('content-type') || ''

  // Prefer JSON when header indicates it
  if (contentType.includes('application/json') || contentType.includes('ld+json')) {
    return response.text().then((text) => {
      let data = null
      if (text) {
        try {
          data = JSON.parse(text)
        } catch (e) {
          // If JSON parsing fails, include a small snippet for debugging
          console.error('Failed to parse JSON response:', e)
          const snippet = text.slice(0, 200)
          return Promise.reject({
            status,
            response: {
              title: 'Invalid JSON response',
              detail: `Failed to parse JSON. Content-Type: ${contentType}. Body (first 200 chars): ${snippet}`,
              violations: [],
            },
          })
        }
      }

      if (!response.ok) {
        return Promise.reject({
          status,
          response: {
            title: !(data instanceof Array) ? data?.['hydra:title'] || data?.title || 'Error' : 'Error',
            detail: !(data instanceof Array)
              ? data?.['hydra:description'] || data?.detail || response.statusText
              : response.statusText,
            violations: !(data instanceof Array) ? data?.violations || [] : data,
          },
        })
      }

      return data
    })
  }

  // Fallback for non-JSON responses (e.g., HTML error pages)
  return response.text().then((text) => {
    if (!response.ok) {
      return Promise.reject({
        status,
        response: {
          title: 'Error',
          detail: text ? text.slice(0, 200) : response.statusText,
          violations: [],
        },
      })
    }

    // For OK non-JSON, return the raw text
    return text
  })
}
